import { notificationsAPI } from './api';

export const BADGE_REFRESH_EVENT = 'projectflow:badge-refresh';

type BadgeCapable = {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

function badgeTarget(): BadgeCapable | null {
  if (typeof navigator !== 'undefined' && 'setAppBadge' in navigator) {
    return navigator as Navigator & BadgeCapable;
  }
  return null;
}

export function supportsAppBadge(): boolean {
  return badgeTarget() !== null;
}

export async function syncAppBadge(count: number): Promise<void> {
  const target = badgeTarget();
  if (!target?.setAppBadge) return;

  try {
    if (count <= 0) {
      await target.clearAppBadge?.();
    } else {
      await target.setAppBadge(Math.min(count, 99));
    }
  } catch {
    /* navegador sin soporte o PWA no instalada */
  }
}

export async function refreshAppBadgeFromApi(): Promise<number> {
  let count = 0;
  try {
    const res = await notificationsAPI.unreadCount();
    count = res.data?.count ?? 0;
  } catch {
    count = 0;
  }

  await syncAppBadge(count);
  window.dispatchEvent(new CustomEvent(BADGE_REFRESH_EVENT, { detail: { count } }));
  return count;
}

export function requestBadgeRefresh(): void {
  refreshAppBadgeFromApi().catch(() => undefined);
}
